import { Action, Reducer } from 'redux';

export interface AppModalState {
    openModal?: boolean,
    open?: boolean,
    severity?: string,
    message?: string,

}

export interface OpenModalAlert {
    type: 'OPEN_MODAL_ALERT',
    openModal: boolean,
    message: string,
    severity: string,
}
export interface SetModalSeverity {
    type: 'SET_MODAL_SEVERITY',
    severity: string
}
export interface SetModalMessage {
    type: 'SET_MODAL_MESSAGE',
    message: string
}
export interface SetModalToClose {
    type: 'SET_MODAL_TO_CLOSE',
    openModal: boolean
}
export type KnownAction = OpenModalAlert | SetModalSeverity | SetModalMessage | SetModalToClose;

export const actionCreators = {
    openModalSuccess: (message: string) => ({ type: 'OPEN_MODAL_ALERT', openModal: true,  message: message, severity: "success" } as OpenModalAlert),
    openModalError: (message: string) => ({ type: 'OPEN_MODAL_ALERT', openModal: true, message: message, severity: "error" } as OpenModalAlert),
    setModalSeverity: (event: string) => ({ type: 'SET_MODAL_SEVERITY', severity: event } as SetModalSeverity),
    setModalMessage: (event: string) => ({ type: 'SET_MODAL_MESSAGE', message: event } as SetModalMessage),
    setModalToClose: () => ({ type: 'SET_MODAL_TO_CLOSE', openModal: false } as SetModalToClose),
};

export const reducer: Reducer<AppModalState> = (state: AppModalState | undefined, incomingAction: Action): AppModalState => {
    if (state === undefined) {
        return {
            open:false,
            openModal: false,
            severity: "success",
            message: "",
        };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'OPEN_MODAL_ALERT':
            return {
                ...state,
                openModal: action.openModal,
                message: action.message,
                severity: action.severity,
            };
        case 'SET_MODAL_SEVERITY':
            return {
                ...state,
                severity: action.severity
            };
        case 'SET_MODAL_MESSAGE':
            return {
                ...state,
                message: action.message
            };
        case 'SET_MODAL_TO_CLOSE':
            return {
                ...state,
                openModal: action.openModal
            };
        default:
            return state;
    }
};